import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';

import { CarouselComponent } from './components/carousel/carousel.component';
import { ItemDirective } from './directives/item.directive';
import { McRAIGridModule } from '../grid/grid.module';
import { McRAIButtonModule } from '../button/button.module';

@NgModule({
  imports: [
    CommonModule,
    PortalModule,
    McRAIGridModule,
    McRAIButtonModule
  ],
  declarations: [
    CarouselComponent,
    ItemDirective
  ],
  exports: [
    CarouselComponent,
    ItemDirective
  ]
})
export class McRAICarouselModule { }
